import { lazy } from 'react'

export const YouAreNotAloneV1 = lazy(() => import('./v1/YouAreNotAloneV1'))
